import { useState } from 'react'

import PlainCheckbox from 'app/common/ui-next/plain-checkbox'
import PlainHelperText from 'app/common/ui-next/plain-helper-text'
import PlainInput from 'app/common/ui-next/plain-input'

import styles from './SellPointSettingsModal.module.scss'

type Props = {
  initialLimit?: number | null
  disabled?: boolean
}

export const ProductQuantityLimit = ({ initialLimit = null, disabled }: Props) => {
  const [withoutRestrictions, setWithoutRestrictions] = useState(initialLimit === null)
  const [value, setValue] = useState(initialLimit === null ? '' : String(initialLimit))

  return (
    <div className={styles.quantityLimit}>
      <label htmlFor="maxProductQuantity" className={styles.quantityLabel}>
        {'Максимальное кол-во одной продукции в покупке'}
      </label>
      <div className={styles.quantityControls}>
        <div className={styles.quantityInputContainer}>
          <PlainInput
            id="maxProductQuantity"
            name="maxProductQuantity"
            value={value}
            inputClassName={styles.quantityInput}
            type="number"
            inputmode="numeric"
            min="1"
            max="99"
            step="1"
            required={!withoutRestrictions}
            disabled={disabled || withoutRestrictions}
            onValue={setValue}
          />
          <PlainHelperText overflowVisible>{'от 1 до 99'}</PlainHelperText>
        </div>
        <PlainCheckbox
          id="withoutProductQuantityRestrictions"
          name="withoutProductQuantityRestrictions"
          value="withoutProductQuantityRestrictions"
          label="Без ограничений"
          className={styles.quantityCheckbox}
          checked={withoutRestrictions}
          disabled={disabled}
          onChange={(event) => setWithoutRestrictions(event.currentTarget.checked)}
        />
      </div>
    </div>
  )
}
